import { render, staticRenderFns } from "./target_table.vue?vue&type=template&id=3487b62b&scoped=true"
import script from "./target_table.vue?vue&type=script&lang=js"
export * from "./target_table.vue?vue&type=script&lang=js"
import style0 from "./target_table.vue?vue&type=style&index=0&id=3487b62b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487b62b",
  null
  
)

export default component.exports